import config from "../../../config";

const url = config.url;

export async function getProcesses(
    year = 0,
    processNum = "",
    crimeType = "",
    finalDecision = "",
    page = 1,
    itemsPerPage = 10,
) {
    const username = config.username;
    const password = config.password;
    const authHeader = "Basic " + btoa(username + ":" + password);
    try {
        const response = await fetch(
            url + "/ProcessFinalDecision/ConsultProcessFinalDecision",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authHeader,
                },
                body: JSON.stringify({
                    Ano: year,
                    NumeroProcesso: processNum,
                    TipoCrime: crimeType,
                    DecisaoFinal: finalDecision,
                    Page: page,
                    NumberItens: itemsPerPage,
                }),
            },
        );
        return response.json();
    } catch (error) {
        console.error(error);
    }
}
